// Self-hosted IBM Plex (bundled by Vite, no third-party CDN at runtime) so the
// app keeps to its network rule: only the LLM proxy/model and the marketing
// waitlist ever leave the origin.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-serif/400.css";
import "@fontsource/ibm-plex-serif/500.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

import "./theme.css";
import "./ui/shell.css";
import "./ui/components.css";

import { App } from "./app/app";
import { IndexedDBRepository } from "./data/idb";
import { SingleViewerLens } from "./lens/single-viewer";
import { CloudProvider } from "./llm/cloud";
import { applyTheme, currentTheme } from "./ui/theme";

applyTheme(currentTheme());

// Persistent storage is requested at first commitment (see ui/storage.ts), with
// an in-app explainer first, rather than on cold first paint.

const root = document.getElementById("app");
if (root) {
  const repo = new IndexedDBRepository();
  const lens = new SingleViewerLens(repo);
  const provider = new CloudProvider(repo);
  new App(root, repo, lens, provider).start();
}
